// removed by extract-text-webpack-plugin
module.exports = {"SetupContent":"_1yKd6iRFThPKa9hnFhporA","SetupCardLayout":"_1MUL-4NekxOc8-_Iwo5LH2","SetupTitle":"_19wHOcI6jYMkmiWyA_JSn-","DefaultButton":"_3KusAUS3HkeQL3an3NmCFy","SetupSyncError":"_1WzeuipLCQnC9PQOawb9ev","SetupLoadingDots":"cdi7kSkpyATfJFMWJfIJu","SetupInput":"_2dFpRE_n4XqFgcmOx5kKzt"};


//////////////////
// WEBPACK FOOTER
// ./src/ConnectedComponents/Setup/index.css
// module id = 43
// module chunks = 1